import React, { useEffect, useState } from "react";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  addData,
  getData,
  ImageLink,
  updateData,
} from "../services/axios.function";
import UpdateButton from "../components/UpdateButton";

const FestivalType = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const isEdit = !!editData;

  const [formData, setFormData] = useState({
    sortOrder: "",
    name: "",
    image: null,
    isActive: true,
  });

  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const fetchLastSortOrder = async () => {
      try {
        const res = await getData("api/festival/get-last-sr-no");
        if (res?.data?.isSuccess) {
          const lastNo = res.data.data?.sortOrder || 0;
          setFormData((prev) => ({ ...prev, sortOrder: lastNo + 1 }));
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong!"
        );
      }
    };
    if (!isEdit) fetchLastSortOrder();
    else {
      setFormData({
        sortOrder: editData.sortOrder || "",
        name: editData.name || "",
        image: editData.image || null,
        isActive: editData.isActive,
      });
    }
  }, [isEdit, editData]);

  const validateForm = () => {
    const newError = {};
    if (!formData.image && !isEdit)
      newError.image = "Image is required";
    if (!formData.name.trim() && !isEdit) newError.name = "Name is required";
    setError(newError);
    return Object.keys(newError).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else if (type === "file") {
      setFormData((prev) => ({ ...prev, image: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    setError((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);

    try {
      const payload = new FormData();
      payload.append("sortOrder", Number(formData.sortOrder));
      payload.append("name", formData.name);
      payload.append("isActive", formData.isActive);
      if (formData.image instanceof File) {
        payload.append("image", formData.image);
      }

      let res;
      if (isEdit) {
        payload.append("_id", editData._id);
        res = await updateData(
          `api/festival/update`,
          payload
        );
      } else {
        res = await addData(`api/festival/add`, payload);
      }

      if (res?.data?.isSuccess) {
        toast.success(res?.data?.message || "Success!");
        navigate(`/festival-type`);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="mb-4">
        <h4>{isEdit ? "Edit Festival Type" : "Add Festival Type"}</h4>
      </div>
      <form className="add-edit-form" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-6 mb-3">
            <label>Sort Order No:</label>
            <input
              type="text"
              name="sortOrder"
              value={formData.sortOrder}
              // onChange={handleChange}
              className="custom-ip"
              readOnly
            />
          </div>

          <div className="col-lg-6 mb-3">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              placeholder="Enter Festival Name"
              value={formData.name}
              onChange={handleChange}
              className={`custom-ip ${error.name ? "is-invalid" : ""}`}
              disabled={isEdit}
            />
            {error.name && (
              <div className="invalid-feedback">{error.name}</div>
            )}
          </div>

          <div className="col-lg-5 mb-3">
            <label>Festival Type Image:</label>
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
              className={`custom-ip ${error.image ? "is-invalid" : ""}`}
            />
            {error.image && (
              <div className="invalid-feedback">{error.image}</div>
            )}
            {formData.image && (
              <div className="mt-2">
                <img
                  src={
                    formData.image instanceof File
                      ? URL.createObjectURL(formData.image)
                      : ImageLink(formData.image)
                  }
                  alt="Preview"
                  className="img-thumbnail"
                  style={{ width: "300px" }}
                  onLoad={(e) => URL.revokeObjectURL(e.target.src)}
                />
              </div>
            )}
          </div>
          <div className="col-lg-4 mb-3">
            <table>
              <tbody>
                <tr>
                  <td>isActive</td>
                  <td className="ps-3">
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        name="isActive"
                        checked={formData.isActive}
                        onChange={handleChange}
                      />
                      <span className="slider" />
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center gap-4">
          <div className="cancel-btn my-3">
            <Link to={`/festival-type`}>
              <button type="button">
                <FaRegArrowAltCircleLeft size={22} />
                Cancel
              </button>
            </Link>
          </div>
          <div className="submit-btn my-3">
            <UpdateButton loading={loading} isEdit={isEdit} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default FestivalType;
